import Checkbox from "@/v2-ui/checkbox"
import Tooltip from "@/v2-ui/tooltip"
import {
  describeTick,
  tickStateOf,
  type TickMeaning,
} from "@/v2-backoffice-client/license/featureGroup/compose/license.featureGroup.placement.utils"

export type LicenseFeatureGroupTickCheckboxProps = {
  meaning: TickMeaning
  isCarriedHere: boolean
  /** Carried by a module or class rule: shown, not toggleable here. */
  disabled?: boolean
  packageName: string
  rowName: string
  otherPackages: readonly string[]
  ariaLabel: string
  onToggle(nextCarried: boolean): void
}

// A package-lens row's checkbox, carrying what the tick means: a full tick
// is access this package gives (a package-only row), a dash is a placement
// (the row is free for every customer today; the tick records that this
// package keeps it if it is ever made package-only), an empty box is not
// carried. The tooltip says it in a sentence, for whichever state the row
// is in. Toggling is on the row's own state, never on the glyph: a dash
// toggles off, like a tick.
function LicenseFeatureGroupTickCheckbox(
  props: LicenseFeatureGroupTickCheckboxProps,
) {
  const {
    meaning,
    isCarriedHere,
    disabled = false,
    packageName,
    rowName,
    otherPackages,
    ariaLabel,
    onToggle,
  } = props

  return (
    <Tooltip>
      <Tooltip.Trigger asChild>
        {/* A disabled button fires no pointer events, so the span is the trigger. */}
        <span className="flex shrink-0 items-center">
          <Checkbox
            checked={tickStateOf(isCarriedHere, meaning)}
            disabled={disabled}
            aria-label={ariaLabel}
            onCheckedChange={() => {
              onToggle(!isCarriedHere)
            }}
          />
        </span>
      </Tooltip.Trigger>
      <Tooltip.Content side="top" align="start" className="max-w-[340px]">
        {describeTick({
          meaning,
          isCarriedHere,
          packageName,
          rowName,
          otherPackages,
        })}
      </Tooltip.Content>
    </Tooltip>
  )
}

export default LicenseFeatureGroupTickCheckbox
